// AddressShimmer.jsx
import React from "react";

const AddressShimmer = () => {
  return (
    <div className="max-w-7xl mx-auto space-y-8 bg-white border border-gray-100 rounded-xl p-4 md:p-6">
      {/* Header */}
      <div className="flex items-center h-14 mt-5 bg-white px-8 shadow-sm">
        <div className="w-10 h-10 bg-gray-300 rounded-full" />
        <div className="flex-1 h-6 bg-gray-300 mx-auto rounded" />
      </div>

      {/* Location input */}
      <div className="w-full mt-4">
        <div className="h-4 w-32 bg-gray-300 mb-2 rounded" />
        <div className="w-full h-10 shimmer rounded" />
      </div>

      {/* Address Form */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-10">
        {Array(6)
          .fill(0)
          .map((_, i) => (
            <div key={i} className="h-10 shimmer rounded" />
          ))}
      </div>

      {/* Google Map */}
      <div className="space-y-2 mt-6">
        <div className="w-full h-60 shimmer rounded" />
        <div className="h-4 w-1/2 bg-gray-300 rounded" />
      </div>

      {/* Delivery Toggle */}
      <div className="flex items-center justify-between max-w-md mt-6">
        <div className="h-4 w-48 bg-gray-300 rounded" />
        <div className="h-6 w-12 shimmer rounded-full" />
      </div>

      {/* Delivery Options */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
        <div className="h-24 shimmer rounded-xl" />
        <div className="h-24 shimmer rounded-xl" />
      </div>

      {/* Update Button */}
      <div className="flex justify-end w-full mt-6">
        <div className="h-10 w-32 bg-gray-300 rounded" />
      </div>
    </div>
  );
};

export default AddressShimmer;
